import { IDomainSearchResult } from "@/redux/slices/domains/types.ts";
import { IButtonProps } from "@template/components/Button";
import * as S from "./styles.ts";
import { Button, H2, Popover } from "@template/components";
import Result from "@template/blocks/domain/DomainNameCustomSearchResults/Result";
import { CircleHelp } from "lucide-react";

const fakeDomainsAmount = 10;
const fakeDomains = Array(fakeDomainsAmount).fill(0);

export type ResultsProps = {
  results?: IDomainSearchResult[];
  title?: string;
  button?: IButtonProps;
  loading: boolean;
  isUnavailable?: boolean;
};

const Results = ({
  results = [],
  title,
  button,
  loading,
  isUnavailable,
}: ResultsProps) => {
  if (!loading && !results.length) return;

  return (
    <S.Wrapper>
      <S.Header>
        {title && <H2>{title}</H2>}
        <span
          style={{
            marginRight: "auto",
            marginLeft: -18,
          }}
        >
          {isUnavailable && (
            <Popover
              tip="Domain unavailable? Transfer-in or place a backorder to snap it when it drops."
              delay={100}
            >
              <S.Icon>
                <CircleHelp />
              </S.Icon>
            </Popover>
          )}
        </span>
        {button?.children && <Button {...button} />}
      </S.Header>
      {(loading ? fakeDomains : results).map((result, i) => (
        <Result
          key={i}
          domain={result}
          domainsLoading={loading}
        />
      ))}
    </S.Wrapper>
  );
};

export default Results;
